import {Injectable} from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {ModelPjFile} from "app/dar/common/services/model-pj/model-pj.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ModelPjFileService extends DaoGeneric<ModelPjFile> {
  private urlUpload = `${environment.baseUrl}/dar/attachmenttemplatefile/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp?: string): string {
    return this.urlUpload;
  }

  public uploadModel(modelPj: ModelPjFile, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('id', modelPj.id.toString());
    formData.append('cmd', 'upload_template');
    formData.append('file', file, file.name);
    formData.append('file_name', file.name);
    return this.httpClient.patch(this.urlUpload, formData);
  }

  public deleteModel(modelPj: ModelPjFile): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('id', modelPj.id.toString());
    formData.append('cmd', 'delete_template');
    return this.httpClient.patch(this.urlUpload, formData);
  }

  public updateModel(modelPj: ModelPjFile): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('id', modelPj.id.toString());
    formData.append('template_type', modelPj.template_type.toString());
    formData.append('template_name', modelPj.template_name);
    formData.append('cmd', 'update_template');
    return this.httpClient.patch(this.urlUpload, formData);
  }
}
